module.exports = __webpack_public_path__ + "media/images/front/materiales_sup-8ec3d416013bc137f750fc7e08bbb988.webp";